const decodeKey = (encodedKey) => {
    if (!encodedKey) {
        return null;
    }
    return encodedKey.replaceAll("&quote;", '"');
};

export { decodeKey };
//# sourceMappingURL=decodeKey.mjs.map
